import React from "react";
import ToolTip, {TooltipContent, TooltipTrigger} from "../Overlays/Tooltip";

export function FormControl ({children, controls = {}}) {
    const {required = false, error = null, type = ""} = controls;
    const className= `form-control ${type} skynet-form-input${required ? " required" : ""} ${error ? "has-error" : ""}`
    
    return <ToolTip>
            <TooltipTrigger className={className}>
                {children}
            </TooltipTrigger>
            {error && (
                <TooltipContent>
                    <div>{error}</div>
                </TooltipContent>
            )}
    </ToolTip>
}